import React, { use, useCallback } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { AppContext } from '../utils/context';
import { logError } from '../utils/misc';

export const LogoutPage: React.FC = () => {
    const { userLoaded, refreshUser, apiAccessor } = use(AppContext);

    const declineLogOut = useCallback(() => {
        document.location.href = '/';
    }, []);

    const acceptLogOutAsync = useCallback(async () => {
        try {
            await toast.promise(
                (async () => {
                    await apiAccessor.fetch('/api/v1/users/sessions', {
                        method: 'DELETE',
                    });
                    await refreshUser();
                })(),
                {
                    success: 'Logged out!',
                    pending: 'Logging out...',
                    error: {
                        render({ data }) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
                            const error = data as Error;
                            return `Error logging out: ${error.message}`;
                        },
                    },
                },
            );

            document.location.href = '/';
        } catch (error: unknown) {
            logError(error);
            await refreshUser();
        }
    }, [refreshUser, apiAccessor]);

    const acceptLogOut = useCallback(() => {
        void (async () => {
            try {
                await acceptLogOutAsync();
            } catch (error: unknown) {
                logError(error);
            }
        })();
    }, [acceptLogOutAsync]);

    if (!userLoaded) {
        return (
            <>
                <h1>Logout</h1>
                <br />
                <h3>Loading...</h3>
            </>
        );
    }

    return (
        <>
            <Modal show>
                <Modal.Header>
                    <Modal.Title>Log out?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to log out?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={declineLogOut} variant="secondary">
                        No
                    </Button>
                    <Button onClick={acceptLogOut} variant="primary">
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <h1>Logout</h1>
            <br />
            <h3>Please see modal dialog</h3>
        </>
    );
};
